// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"Governance_boxContainer__b10Pv"};